// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__WIzS8","footer":"ModalCreateQualiphyProcedure_footer__3EuUl","additionData":"ModalCreateQualiphyProcedure_additionData__ZWdI8"};